import React, {useEffect, useState} from 'react';
import {Button, Card, Container, Grid, Loader, Popup, Progress} from 'semantic-ui-react';
/* import CommercialTable from '../../../common/components/commercialTable/commercialTable'; */
import {useDispatch, useSelector} from 'react-redux';
import EtaManagementTable from './etaManagementTable';
import EtaManagementInvoiceDateModal from './etaManagementInvoiceDateModal';
import {Link} from 'react-router-dom';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import moment from 'moment';
import {Actions} from '../../actions';
import EtaManagementDetailModal from './etaManagementDetailModal';

const etaManagementColumns = (setShowFechaFacturaModal, setShowRowDetailModal) => [
  {
    'Header': '% Avance',
    'accessor': 'follow_percentage',
    'Cell': ({row}) => {
      return (<Container fluid style={{'minWidth': '120px'}} className='follow-percentage'>
        <Progress progress='percent' style={{'margin': 0}}
          success={row.original.follow_percentage === 1}
          indicating={row.original.follow_percentage !== 1}
          percent={row.original.follow_percentage * 100} />
      </Container>
      );
    },
  },
  {
    'Header': 'Estado ABIS',
    'accessor': 'abis_status',
    'Cell': ({row}) => {
      return <b>{row.original?.abis_status && row.original?.abis_status}</b>;
    },
  },
  {
    'Header': 'Cant. Líneas ABIS',
    'accessor': 'abis_lines_qty',
    'Cell': ({row}) => {
      return <Button circular style={{'padding': '5px 8px'}} content={row.original.abis_lines_qty}
        onClick={() => setShowRowDetailModal(row.original)} color='linkedin' />;
    },
  },
  {
    'Header': '# Pedido',
    'accessor': 'order_number',
  },
  {
    'Header': 'Código de Parte',
    'accessor': 'part_code',
    'Cell': ({row}) => {
      return (
        <Popup size='large' hoverable inverted
          trigger={<div>{row.original.part_code}</div>} content={row.original.part_name} />
      );
    },
  },
  {
    'Header': 'Pedido',
    'accessor': 'order_code',
  },
  {
    'Header': 'Estado Concesionario',
    'accessor': 'status_order_dealer',
  },
  {
    'Header': 'Fecha Pedido',
    'accessor': 'order_date',
  },
  {
    'Header': 'Fecha Proceso TDE',
    'accessor': 'tde_process_date',
  },
  {
    'Header': 'Fecha Proceso ABIS',
    'accessor': 'abis_process_date',
  },
  {
    'Header': 'Tiempo desde el pedido',
    'accessor': 'days_from_order',
  },
  {
    'Header': 'Aviso Seguimiento',
    'accessor': 'warning',
  },
  {
    'Header': 'Tiempo desde el proceso ABIS',
    'accessor': 'days_from_abis_process',
  },
  {
    'Header': 'Cant. ordenada',
    'accessor': 'ord_qty',
  },
  {
    'Header': 'Cant. procesada',
    'accessor': 'prc_qty',
  },
  {
    'Header': 'Cant. cancelada',
    'accessor': 'cancel_qty',
  },
  {
    'Header': 'Cant. embarcada',
    'accessor': 'shipped_qty',
  },
  {
    'Header': 'Próximo ABIS ETD',
    'accessor': 'next_abis_etd',
  },
  {
    'Header': 'Observaciones',
    'accessor': 'order_observation',
  },
  {
    'Header': 'Fecha Factura Proveedor',
    'accessor': 'tde_process_invoice_date',
    'Cell': ({row}) => {
      if (row.original?.tde_process_invoice_date_real === null) {
        return (
          <b><Link onClick={() => setShowFechaFacturaModal(row.original)}>
            {row.original?.tde_process_invoice_date &&
              moment(row.original.tde_process_invoice_date).format(dateFormatShow)}
          </Link></b>
        );
      }
      return <b>{moment(row.original?.tde_process_invoice_date_real).format(dateFormatShow)}</b>;
    },
  },
  {
    'Header': 'ETA Standard',
    'accessor': 'eta_standard_date',
  },
  {
    'Header': 'ETA Actualizada',
    'accessor': 'eta_updated_date',
  },
];

const {
  getEtaManagementDetail,
} = Actions;

const EtaManagementList = () => {
  const {loading, list} = useSelector((state) => state.dealerOrdersEtaManagement);
  const [showFechaFacturaModal, setShowFechaFacturaModal] = useState(null);
  const [showRowDetailModal, setShowRowDetailModal] = useState(null);
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (showRowDetailModal) {
      dispatch(getEtaManagementDetail(showRowDetailModal.sequence));
    }
  }, [showRowDetailModal]);

  return (<Card raised fluid>
    <Grid>
      <Grid.Row>
        <Grid.Column>
          {
            loading ?
              <Container fluid>
                <Loader active inline='centered'>
                  Consultando...
                </Loader>
              </Container> :
              <>
                <EtaManagementTable
                  tableColumns={etaManagementColumns(setShowFechaFacturaModal, setShowRowDetailModal)}
                  tableData={list}
                />
                {showFechaFacturaModal &&
                <EtaManagementInvoiceDateModal
                  setShowFechaFacturaModal={setShowFechaFacturaModal}
                  showFechaFacturaModal={showFechaFacturaModal !== null}
                  data={showFechaFacturaModal}
                />}
                {showRowDetailModal &&
                <EtaManagementDetailModal
                  setShowRowDetailModal={setShowRowDetailModal}
                  showRowDetailModal={showRowDetailModal !== null}
                  selected={showRowDetailModal}
                />}
              </>
          }
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Card>
  );
};

export default EtaManagementList;
